import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, Music } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          {/* 404 graphic */}
          <div className="relative mb-8">
            <div className="text-[150px] md:text-[200px] font-bold text-white/5 leading-none select-none">
              404
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-24 h-24 rounded-full bg-[#8146FF]/20 flex items-center justify-center">
                <Music size={48} className="text-[#8146FF]" />
              </div>
            </div>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold mb-4">
            Pagina niet gevonden
          </h1>
          <p className="text-white/60 mb-8">
            Deze pagina bestaat niet of is verplaatst. Misschien vind je wat je zoekt via de links hieronder.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-[#8146FF] hover:bg-[#6a35d9] px-6 py-3 rounded-full font-medium transition"
            >
              <Home size={18} />
              Naar home
            </Link>
            <Link
              to="/zoeken"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 px-6 py-3 rounded-full font-medium transition border border-white/20"
            >
              <Search size={18} />
              Bekijk oproepen
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
